export default __webpack_public_path__ + "static/item_16-329e19f9408d278eaaf5e7980eb04795.jpg";